/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkReasontype } from '../models/work-reasontype';

@Injectable({ providedIn: 'root' })
export class WorkReasontypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reasontypesV2ControllerGetAll()` */
  static readonly ReasontypesV2ControllerGetAllPath = '/v2/reasontypes/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reasontypesV2ControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reasontypesV2ControllerGetAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkReasontype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReasontypesV2Service.ReasontypesV2ControllerGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkReasontype>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reasontypesV2ControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reasontypesV2ControllerGetAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkReasontype>> {
    return this.reasontypesV2ControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkReasontype>>): Array<WorkReasontype> => r.body)
    );
  }

}
